import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Grid, Button } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import { useStyles } from './styles.js';
import { HowToDialog } from '..';

class WmpoHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openDialog: props.agree_disclaimer && !props.open ? true : false,
    };

    this.dlClose = this.dlClose.bind(this);
  }

  dlClose() {
    this.setState({ openDialog: false });
    if (this.props.agree_disclaimer && !this.props.open) {
      this.props.agreeDisclaimer();
    }
  }

  render() {
    const { classes, disclaimer } = this.props;
    const { openDialog } = this.state;
    return (
      <Grid container className={classes.headerRoot}>
        <Grid>
          <img
            className={classes.headerImg}
            src={
              'https://bestdayever-photos.s3.amazonaws.com/WMPO+CHALLENGE+LOGO.png'
            }
          />
        </Grid>
        <Grid>
          <Button
            className={classes.headerButton}
            onClick={() => {
              this.setState({ openDialog: true });
            }}
          >
            How to play
          </Button>
          <HowToDialog
            disclaimer={disclaimer}
            dlClose={this.dlClose}
            openDialog={openDialog}
          />
        </Grid>
      </Grid>
    );
  }
}

WmpoHeader.propTypes = {
  className: PropTypes.string,
};

export default withStyles(useStyles)(WmpoHeader);
